
(function () {
    
    const ie = navigator.userAgent.indexOf('MSIE ') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0 || navigator.userAgent.indexOf('Edge/') >= 0;
    
    (function main() {
        Promise.all([
            // wait for the DOMContentLoaded event
            new Promise(function(resolve,reject){document.addEventListener('DOMContentLoaded', resolve)}),

            // Wait for fonts to load
            new Promise(function(resolve,reject){WebFont.load({
                
                classes: true,
                
                custom: {
                    families: ['Futura-Light','Futura-Book','Futura-Medium','Baskerville','Baskerville-Italic','Baskerville-SemiBold'],
                    urls: ['fonts/stylesheet.css'],
                },
                active: resolve,
            })}),
        ]).then(init);
    }());

    function init() {
        console.log('loaded')
        //let scrollReference = gid('scrollReference');
        
        let verticalScrolling = gid('verticalScrolling');
        let mainFrame = gid('mainFrame');
        let fullpage = true;
        if(mainFrame.offsetWidth <= 768) fullpage = false;
        let headerHeight = 95;
        let highlightPreLoad = new Image();
        highlightPreLoad.src = 'media/img/highlight.png';

        let highlightPreLoad2 = new Image();
        highlightPreLoad2.src = 'media/img/m-thumb-print.png';
        
        let baselineW = 1280;
        var currentRedText = '';
        var currentRedTextOpen = false;
        let redTextWrapper = gid('redTextWrapper');

        redTextWrapper.addEventListener('click',clearOverlay);

        let tracking = gid('tracking');
        var cachebuster = Math.round(new Date().getTime() / 1000);
        tracking.innerHTML = '<A class="mobile" HREF=""https://ad.doubleclick.net/ddm/jump/N624.8535.CNNNETWORK/B20618953.213693408;sz=1x1;ord=`+cachebuster+`?"">';
        tracking.innerHTML += '<IMG class="mobile" SRC=""https://ad.doubleclick.net/ddm/ad/N624.8535.CNNNETWORK/B20618953.213693408;sz=1x1;ord=`+cachebuster+`;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?"" BORDER=0 WIDTH=1 HEIGHT=1 ALT=""Advertisement""></A>';
        tracking.innerHTML += '<A class="tablet" HREF=""https://ad.doubleclick.net/ddm/jump/N624.8535.CNNNETWORK/B20618953.213693411;sz=1x1;ord=`+cachebuster+`?"">';
        tracking.innerHTML += '<IMG class="tablet" SRC=""https://ad.doubleclick.net/ddm/ad/N624.8535.CNNNETWORK/B20618953.213693411;sz=1x1;ord=`+cachebuster+`;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?"" BORDER=0 WIDTH=1 HEIGHT=1 ALT=""Advertisement""></A>';
        tracking.innerHTML += '<A class="desktop" HREF=""https://ad.doubleclick.net/ddm/jump/N624.8535.CNNNETWORK/B20618953.213693414;sz=1x1;ord=`+cachebuster+`?"">';
        tracking.innerHTML += '<IMG class="desktop" SRC=""https://ad.doubleclick.net/ddm/ad/N624.8535.CNNNETWORK/B20618953.213693414;sz=1x1;ord=`+cachebuster+`;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?"" BORDER=0 WIDTH=1 HEIGHT=1 ALT=""Advertisement""></A>';
        tracking.innerHTML += '<img class="mobile" src="https://secure.insightexpressai.com/adServer/adServerESI.aspx?script=false&bannerID=2335303&rnd=`+cachebuster+`&redir=https://secure.insightexpressai.com/adserver/1pixel.gif">';
        tracking.innerHTML += '<img class="tablet" src="https://secure.insightexpressai.com/adServer/adServerESI.aspx?script=false&bannerID=2335304&rnd=`+cachebuster+`&redir=https://secure.insightexpressai.com/adserver/1pixel.gif">';
        tracking.innerHTML += '<img class="desktop" src="https://secure.insightexpressai.com/adServer/adServerESI.aspx?script=false&bannerID=2335302&rnd=`+cachebuster+`&redir=https://secure.insightexpressai.com/adserver/1pixel.gif">';

        function clearOverlay(){
            currentRedTextOpen = false;
            redTextWrapper.style.display = 'none';
            currentRedText.style.display = 'none';
        }

        function ratio(n){
            n = n/baselineW*window.innerWidth;
            return n;
        }
        
        
        if (ie) {
            document.body.addEventListener('wheel', function(event){
                event.preventDefault();
                scroll();
            });
        }

        window.addEventListener('scroll',scroll);

        let trailerWrapper = gid('trailerWrapper');
        let playBtn = gid('playBtn');
        let fullscreenBtn = gid('fsBtn');
        let video7 = gid('video7');

        fullscreenBtn.addEventListener('click',function(){
            gtag('event', 'video trailer fullscreen');
            if (video7.requestFullscreen) {
            video7.requestFullscreen();
            } else if (video7.mozRequestFullScreen) {
            video7.mozRequestFullScreen();
            } else if (video7.webkitRequestFullscreen) {
            video7.webkitRequestFullscreen();
            }
        });

        fullscreenBtn.style.display = 'none';

        let isPlaying = false;
        let isFullScreen = false;

        playBtn.addEventListener('click',function(){
            if(isPlaying){
                video7.pause();
                playBtn.style.opacity = 1;
                isPlaying = false;
                fullscreenBtn.style.display = 'none';
                gtag('event', 'video trailer pause');
            }
            else{
                video7.play();
                playBtn.style.opacity = 0;
                isPlaying = true;
                fullscreenBtn.style.display = 'block';
                gtag('event', 'video trailer play');
            }
        });

        video7.addEventListener("ended", function(){
            video7.pause();
            playBtn.style.opacity = 1;
            isPlaying = false;
            fullscreenBtn.style.display = 'none';
            gtag('event', 'video trailer complete');
        });
        let bgPos = gid('sprite1Element0');
        let leftGuyPos = gid('sprite1Element1');
        let middleGuyPos = gid('sprite1Element2');
        let rightGuyPos = gid('sprite1Element3');
        
        bgPos.style.left = 0+'px';
        leftGuyPos.style.left = ratio(-80)+'px';
        middleGuyPos.style.left = ratio(-40)+'px';
        rightGuyPos.style.left = 0+'px';
        
        let emotionBgPos = gid('sprite2Element1');
        emotionBgPos.style.left = ratio(60)+'px';
        emotionBgPos.style.opacity = 0;
        let emotionGirlPos = gid('sprite2Element3');
        emotionGirlPos.style.left = ratio(-20)+'px';

        let personaBgPos = gid('sprite3Element1');
        let personaguyPos = gid('sprite3Element2');
        let personaPetePos = gid('sprite3Element3');
        personaBgPos.style.opacity = 0;
        personaguyPos.style.left = 0+'px';
        personaguyPos.style.top = ratio(30)+'px';
        personaPetePos.style.left = 0+'px';

        let gunLady = gid('sprite5Animation1');
        let gunLady38 = gid('sprite5Animation2');
        gunLady.style.bottom = 0+'px';
        gunLady38.style.bottom = 0+'px';

        let disappearPos = gid('sprite6Element2');
        disappearPos.style.left = 0+'px';
        disappearPos.style.top = ratio(100)+'px';

        let sprite1Overlay = gid('sprite1Overlay');
        
        var bgImg = new Image();
        bgImg.onload = imgLoaded;
        if(fullpage) bgImg.src = 'media/img/m-hero-bg.jpg';
        else bgImg.src = 'media/img/m-hero-bg.jpg';

        var leftGuyImg = new Image();
        leftGuyImg.onload = imgLoaded;
        if(fullpage) leftGuyImg.src = 'media/img/hero-left.png';
        else leftGuyImg.src = 'media/img/m-hero-left.png';

        var centerGuyImg = new Image();
        centerGuyImg.onload = imgLoaded;
        if(fullpage) centerGuyImg.src = 'media/img/hero-center.png';
        else centerGuyImg.src = 'media/img/m-hero-center.png';

        var rightGuyImg = new Image();
        rightGuyImg.onload = imgLoaded;
        if(fullpage) rightGuyImg.src = 'media/img/hero-right.png';
        else rightGuyImg.src = 'media/img/m-hero-right.png';

        imgInc = 0;
        function imgLoaded(){
            imgInc++;
            if(imgInc==4){
                sprite1Overlay.style.opacity = 0;
            }
        }
        let animations = verticalScrolling.queryAll('.animate-item');
        
        function scroll(){
           
            var scrollY = window.pageYOffset;
            if(currentRedTextOpen){
                clearOverlay();
            }

            animations.forEach(function(ele){
                
                
                let rect = ele.getBoundingClientRect();
                let elementHeight = ele.offsetHeight;

                
                if((rect.bottom > 0) && (rect.top < window.innerHeight)){//make sure to only track items that are in the viewport
                    let isVideo = (ele.className.indexOf('video-wrapper')!==-1);
                    let isSprite = (ele.className.indexOf('sprite-wrapper')!==-1);
                    
                    let startPoint = ele.getAttribute('startPoint').split(',');
                    let animateStartPoint = setVideoStartEndPoints(startPoint[0]);
                    let pageStartPoint = setPageStartEndPoints(startPoint[1]);

                    function setVideoStartEndPoints(p){
                        let point = p.toLowerCase();
                        let result = rect.top;
                        if(point==='top') result = rect.top;
                        else if(point==='middle') result = rect.top+(elementHeight/2);
                        else if(point==='bottom') result = rect.bottom;
                        return result;
                    }

                    function setPageStartEndPoints(p){
                        let point = p.toLowerCase();
                        let result = rect.top;
                        if(point==='top') result = 0;
                        else if(point==='middle') result = window.innerHeight/2;
                        else if(point==='bottom') result = window.innerHeight;
                        else if(point.indexOf('%')!==-1){
                            let num = parseInt(point.split('%').join(''));
                            result = (window.innerHeight/100)*num;
                        }
                        else result = parseInt(point);
                        return result;
                    }

                    /*if(isVideo){
                        let endPoint = ele.getAttribute('endPoint').split(',');
                        let animateEndPoint = setVideoStartEndPoints(endPoint[0]);
                        let pageEndPoint = setPageStartEndPoints(endPoint[1]);
                        let poster = ele.querySelector('.poster');//gid(ele.firstElementChild.id+'Poster');

                        if((animateStartPoint < pageStartPoint) && (animateEndPoint > pageEndPoint)){
                            let scrollDistance = (pageEndPoint-pageStartPoint)+(animateEndPoint-animateStartPoint);
                            if(scrollDistance < 0) scrollDistance = -scrollDistance;
                            let videoPlayer = ele.querySelector('.video-bg');
                            let frames = (pageStartPoint-animateStartPoint)*(videoPlayer.duration/scrollDistance);
                            videoPlayer.currentTime = frames;
                        }

                        if(animateEndPoint < pageEndPoint){
                            
                            if(poster.className==='poster posterOff'){
                                poster.className = 'poster posterOn';
                                poster.style.display = 'block';
                            }
                        }
                        else{
                            if(poster.className==='poster posterOn'){
                                poster.className = 'poster posterOff';
                                poster.style.display = 'none'; 
                            }
                        }

                    }
                    else*/ 
                    if(isSprite){
                        let endPoint = ele.getAttribute('endPoint').split(',');
                        let animateEndPoint = setVideoStartEndPoints(endPoint[0]);
                        let pageEndPoint = setPageStartEndPoints(endPoint[1]);
                        
                         if((animateStartPoint < pageStartPoint) && (animateEndPoint > pageEndPoint)){
                            let scrollDistance = (pageEndPoint-pageStartPoint)+(animateEndPoint-animateStartPoint);
                            if(scrollDistance < 0) scrollDistance = -scrollDistance;
                            
                            if(ele.id==='spriteWrapper1'){
                                //let bg = gid('sprite1Img1');
                                let animationDuration = 100;
                                let frames = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                                bgPos.style.left = 0+'px';
                                leftGuyPos.style.left = ratio(-80)+'px';
                                middleGuyPos.style.left = ratio(-40)+'px';
                                rightGuyPos.style.left = ratio(0)+'px';
                                let bg = gid('sprite1Animation0');
                                let leftGuy = gid('sprite1Animation1');
                                let middleGuy = gid('sprite1Animation2');
                                let rightGuy = gid('sprite1Animation3');
                                
                                //bg.style.left = (ratio((-40)/animationDuration*frames))+'px';
                                leftGuy.style.left = (ratio(80/animationDuration*frames))+'px';
                                middleGuy.style.left = (ratio(100/animationDuration*frames))+'px';
                                rightGuy.style.left = (ratio(120/animationDuration*frames))+'px';
                                //let test = ();
                            };

                            if(ele.id==='spriteWrapper2'){
                                let animationDuration = 100;
                                let frames = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                                emotionBgPos.style.left = ratio(60)+'px';
                                emotionBgPos.style.opacity = (1)/animationDuration*frames;
                                emotionGirlPos.style.left = ratio(-20)+'px';
                                let bg = gid('sprite2Animation1');
                                let girl = gid('sprite2Animation3');
                                
                                bg.style.left = (ratio((-60)/animationDuration*frames))+'px';
                                girl.style.left = (ratio(20/animationDuration*frames))+'px';
                                //let test = ();
                            };
                            /*
                            let animationDuration = 200;
                            let frames = Math.round(((pageStartPoint-animateStartPoint)*(animationDuration/scrollDistance)));
                            let things = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                            
                             */
                            if(ele.id==='spriteWrapper3'){
                                let animationDuration = 100;
                                let frames = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                                personaBgPos.style.opacity = (1)/animationDuration*frames;
                                personaguyPos.style.left = 0+'px';
                                personaguyPos.style.top = ratio(30)+'px';
                                personaPetePos.style.left = 0+'px';

                                
                                let guy = gid('sprite3Animation2');
                                let pete = gid('sprite3Animation3');
                                
                                guy.style.left = (ratio((20)/animationDuration*frames))+'px';
                                guy.style.top = (ratio((-30)/animationDuration*frames))+'px';
                                pete.style.left = (ratio((-20)/animationDuration*frames))+'px';
                                //let test = ();
                                
                            };

                            if(ele.id==='spriteWrapper5'){
                                //let bg = gid('sprite1Img1');
                                let animationDuration = 100;
                                let frames = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                                
                                
                                let baselineH = 850;
                                let ladyEndW = 1260;//1260;//1240
                                let ladyEndH = 840;//840;//830
                                let gunEndW = 1180;//1230;//1180
                                let gunEndH = 812;//831;//812
                                
                                gunLady.style.width = (ratio(baselineW)-ratio(((baselineW-ladyEndW))/animationDuration*frames))+'px';
                                gunLady.style.height = (ratio(baselineH)-ratio(((baselineH-ladyEndH))/animationDuration*frames))+'px';
                                
                                gunLady38.style.width = (ratio(baselineW)-(ratio((baselineW-gunEndW)/animationDuration*frames)))+'px';
                                gunLady38.style.height = (ratio(baselineH)-(ratio((baselineH-gunEndH)/animationDuration*frames)))+'px';
                                
                                gunLady.style.bottom = 0+'px';
                                gunLady38.style.bottom = 0+'px';
                                //let test = ();
                                
                            };

                            if(ele.id==='spriteWrapper6'){
                                //let bg = gid('sprite1Img1');
                                let animationDuration = 100;
                                let frames = Math.round((animationDuration/scrollDistance)*(pageStartPoint-animateStartPoint));
                                disappearPos.style.left = 0+'px';
                                disappearPos.style.top = ratio(100)+'px';
                                
                                let disappear = gid('sprite6Animation2');
                                disappear.style.left = (ratio((390)/animationDuration*frames))+'px';
                                disappear.style.bottom = (ratio((100)/animationDuration*frames))+'px';
                            };

                        }
                    }
                    else{
                        if((animateStartPoint < pageStartPoint)){
                            let str = ele.textContent;
                            let htm = ele.innerHTML;
                            let throttle = 1;
                            let chars = Math.round(pageStartPoint-animateStartPoint);
                            let scrollDistance = str.length*throttle;
                            var a = str;
                            var b = "</span>";
                            
                            var position = chars/throttle;
                            var output = [a.slice(0, position), b, a.slice(position)].join('');

                            if(ie){
                                ele.innerHTML = '<span class="highlight-inner-IE">'+output;//IE11 busts my highlight effect
                            }
                            else{
                                ele.innerHTML = '<span class="highlight-inner">'+output;
                            }


                            
                            if(chars >= scrollDistance){
                                
                                ele.className = 'highlight';
                                animations = verticalScrolling.queryAll('.animate-item');
                                chars = scrollDistance;

                                let index = ele.getAttribute('targetIndex');
                                let redboxtxt = document.getElementById('redtextPos'+index);
                                if(fullpage){ 
                                    gtag('event', 'red text box'+index+' revealed');
                                }
                                else{
                                    gtag('event', 'thumbprint'+index+' revealed');
                                }
                                let thumbPrint = document.createElement('div');
                                ele.parentNode.appendChild(thumbPrint);

                                thumbPrint.className = 'mobile thumbPrint';
                                thumbPrint.style.right = 20+'px';
                                thumbPrint.style.top = ele.offsetTop+'px';
                                thumbPrint.style.opacity = 1;
                                thumbPrint.addEventListener('click',function(){
                                    gtag('event', 'thumb print'+index+' clicked');
                                    let item = gid('redtextPos'+index);
                                    let parent = item.parentNode;
                                    parent.removeChild(item);
                                    redTextWrapper.appendChild(item);
                                    redTextWrapper.style.display = 'block';
                                    currentRedText = item;
                                    currentRedText.style.display = 'block';
                                    currentRedTextOpen = true;
                                    
                                    
                                });
                                let distance = redboxtxt.offsetTop-ele.offsetTop;
                                if(distance < 0) distance = -distance;
                                
                                let x = 20;
                                if(redboxtxt.offsetTop>ele.offsetTop) x = -(distance-20);
                                let w = 110;
                                let lineWrapper = document.createElement('div');
                                redboxtxt.appendChild(lineWrapper);

                                let line = document.createElement('canvas');
                                line.style.top = 0+'px';
                                line.style.left = 0+'px';
                                lineWrapper.appendChild(line);
                                line.className = 'line';
                                //line.style.width = w+'px';
                                line.style.height = (distance)+'px';
                                line.width  = line.offsetWidth;
                                line.height = distance;

                                lineWrapper.className = 'lineWrapper';
                                lineWrapper.style.top = x+'px';
                                lineWrapper.style.left = '-'+(line.offsetWidth+20)+'px';
                                //lineWrapper.style.width = w+'px';
                                lineWrapper.style.height = (distance)+'px';

                                let ctx=line.getContext("2d");
                                ctx.beginPath();
                                ctx.lineWidth=1;
                                ctx.strokeStyle="#D0021B";
                                if(redboxtxt.offsetTop>ele.offsetTop){
                                    ctx.moveTo(5,5);
                                    ctx.quadraticCurveTo((line.offsetWidth/2)+(distance/10),(distance/2)-(distance/10),line.offsetWidth-5,(distance-5));
                                    //ctx.lineTo(line.offsetWidth-5,(distance-5));
                                }else{
                                    ctx.moveTo(5,(distance-5));
                                    ctx.quadraticCurveTo((line.offsetWidth/2)+(distance/10),(distance/2)+(distance/10),line.offsetWidth-5,5);
                                    //ctx.lineTo(line.offsetWidth-5,5);
                                }
                                
                                ctx.stroke();
                                //line.style.opacity = 1;
                                lineWrapper.style.width = w+'px';
                                redboxtxt.style.opacity = 1;
                                
                            }
                        }
                    }
                }
            });
        }
    }

    window.addEventListener("resize", scroll);

}());

function gid(s){
    let ele = document.getElementById(s);
    return ele;
}

function delayed(t,func){
    window.requestAnimationFrame(countTimer);
    var delayObj = {};
    delayObj.steps = t*60;
    delayObj.inc = 0;

    function countTimer(){
        delayObj.inc++;
        if(delayObj.inc < delayObj.steps){
            window.requestAnimationFrame(countTimer);
        }
        else{
            func();
        }
    }
};

function delayedCall(t,f){
    new delayed(t,f);
}